import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomysorecabservice() {



    const cardData = {




keyword: "Belgaum to Mysore Cab Service",

headingDescription: "Belgaum Taxi Service provides reliable and comfortable Belgaum to Mysore cab service for families, business travelers, tourists, students, and corporate clients looking for safe and convenient outstation transportation. Whether you need a one-way taxi, round-trip cab, or a customized sightseeing journey from Belgaum to Mysore, we offer flexible travel solutions with professional drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. We provide doorstep pickup from your preferred location in Belgaum, comfortable highway travel, flexible departure timings, transparent pricing, and 24/7 customer assistance for a hassle-free journey. Belgaum Taxi Service helps travelers explore Mysore's famous royal attractions, temples, gardens, heritage locations, and nearby tourist destinations with complete travel convenience. Whether you are planning a family vacation, honeymoon trip, corporate visit, educational tour, medical travel, or weekend getaway, our Belgaum to Mysore taxi service ensures a smooth and enjoyable experience. With experienced chauffeurs, clean vehicles, customer-focused service, and easy booking options, we make long-distance travel between Belgaum and Mysore safe, comfortable, and memorable.",

topPlaces: [

  {
    title: "Srirangapatna",
    description: "Srirangapatna is a historic town near Mysore known for Tipu Sultan's heritage sites, forts, temples, palaces, and important historical landmarks."
  },
    {
    title: "Mysore Palace",
    description: "Mysore Palace is the most famous attraction in Mysore, known for its grand royal architecture, beautiful interiors, historical importance, and spectacular illumination during evenings."
  },
  {
    title: "Chamundi Hills",
    description: "Chamundi Hills is a popular spiritual and sightseeing destination offering panoramic views of Mysore city. The Chamundeshwari Temple located on the hill attracts thousands of visitors every year."
  },
  {
    title: "Brindavan Gardens",
    description: "Brindavan Gardens is a beautifully designed garden near Krishnaraja Sagar Dam, famous for musical fountains, colorful landscapes, and peaceful evening views."
  },
  {
    title: "Mysore Zoo",
    description: "Mysore Zoo is one of Karnataka's popular family attractions, featuring various animals and birds in a well-maintained environment suitable for children and families."
  },
  {
    title: "St. Philomena's Cathedral",
    description: "St. Philomena's Cathedral is a beautiful Gothic-style church known for its impressive architecture, peaceful atmosphere, and cultural significance in Mysore."
  },
  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station near Mysore known for coffee plantations, waterfalls, forests, trekking spots, and pleasant weather, making it a popular extension for holiday trips."
  },
  {
    title: "Ooty",
    description: "Ooty is a famous hill station known for tea gardens, lakes, viewpoints, gardens, and scenic mountain landscapes. Many travelers combine Mysore and Ooty trips for a complete South India tour."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business destination with corporate offices, technology parks, shopping areas, and entertainment attractions. It is a popular stop for travelers visiting Mysore."
  },
  {
    title: "Wayanad",
    description: "Wayanad is a scenic destination known for wildlife, waterfalls, caves, forests, and plantations. It is an ideal addition for travelers planning an extended Karnataka and Kerala tour."
  }
],




"services": [
  {
    "name": "Belgaum to Mysore Cab Service",
    "description": "Book Belgaum to Mysore Cab Service for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, and SUV options for family trips, business travel, sightseeing, airport transfers, and long-distance journeys with flexible one way and round trip booking."
  },
  {
    "name": "Belgaum to Mysore Cab",
    "description": "Hire Belgaum to Mysore Cab for a smooth and convenient road journey with experienced drivers, clean vehicles, comfortable seating, and transparent pricing. Doorstep pickup and flexible travel options make it suitable for families, couples, business travelers, and groups."
  },
  {
    "name": "Belgaum to Mysore Taxi",
    "description": "Choose Belgaum to Mysore Taxi for dependable outstation transportation with professional chauffeurs and comfortable AC cars. Travel conveniently for holidays, business visits, family functions, sightseeing, and personal journeys with multiple vehicle choices."
  },
  {
    "name": "Belgaum to Mysore Taxi Service",
    "description": "Book Belgaum to Mysore Taxi Service for reliable long-distance travel with punctual pickup, courteous drivers, well-maintained vehicles, and affordable travel plans. Enjoy a comfortable journey with convenient booking and flexible scheduling."
  },
  {
    "name": "Belgaum to Mysore One Way Cab",
    "description": "Reserve Belgaum to Mysore One Way Cab for economical single-trip transportation without unnecessary return charges. Get comfortable AC vehicles, professional chauffeurs, doorstep pickup, and convenient booking for your intercity journey."
  },
  {
    "name": "Belgaum to Mysore One Way Taxi",
    "description": "Choose Belgaum to Mysore One Way Taxi for affordable point-to-point travel with experienced drivers and clean, comfortable vehicles. Ideal for relocation, business travel, family visits, and personal journeys."
  },
  {
    "name": "Belgaum to Mysore Cab Booking",
    "description": "Complete Belgaum to Mysore Cab Booking with an easy reservation process and multiple vehicle options. Select a Sedan, Ertiga, Innova Crysta, or SUV according to passenger capacity, luggage requirements, and travel preferences."
  },
  {
    "name": "Belgaum to Mysore Taxi Booking",
    "description": "Book Belgaum to Mysore Taxi Booking for a convenient travel experience with quick reservation assistance, professional chauffeurs, comfortable AC vehicles, and flexible pickup arrangements for families and business travelers."
  },
  {
    "name": "Belgaum to Mysore Car Rental",
    "description": "Hire Belgaum to Mysore Car Rental with driver for flexible outstation transportation. Our rental options are suitable for sightseeing, family holidays, corporate visits, events, and extended travel plans with comfortable vehicles."
  },
  {
    "name": "Belgaum to Mysore Outstation Cab",
    "description": "Travel with Belgaum to Mysore Outstation Cab for safe and comfortable long-distance transportation. Get experienced chauffeurs, spacious AC vehicles, flexible pickup schedules, and convenient one way or round trip options."
  },
  {
    "name": "Belgaum to Mysore Innova Crysta Cab",
    "description": "Book Belgaum to Mysore Innova Crysta Cab for premium outstation travel with spacious seating, generous luggage space, comfortable interiors, and professional chauffeur service. It is an excellent choice for families, executives, and group journeys."
  },
  {
    "name": "Belgaum to Mysore Ertiga Cab",
    "description": "Choose Belgaum to Mysore Ertiga Cab for practical and comfortable 6 to 7 seater travel. With spacious interiors, AC comfort, and experienced drivers, it is suitable for family vacations, small groups, airport transfers, and business trips."
  },
  {
    "name": "Belgaum to Mysore Sedan Cab",
    "description": "Book Belgaum to Mysore Sedan Cab for economical and comfortable intercity travel. Enjoy clean AC cars, comfortable seating, professional chauffeurs, and reliable pickup arrangements for couples, small families, and business travelers."
  },
  {
    "name": "Belgaum to Mysore Round Trip Cab",
    "description": "Reserve Belgaum to Mysore Round Trip Cab for convenient return travel with flexible schedules and comfortable vehicles. Ideal for sightseeing, family vacations, weekend trips, business visits, and planned return journeys."
  },
  {
    "name": "Belgaum to Mysore Private Taxi",
    "description": "Hire Belgaum to Mysore Private Taxi for an exclusive journey with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible travel timings, comfortable seating, and personalized transportation for family and business travel."
  },
  {
    "name": "Cheap Belgaum to Mysore Cab",
    "description": "Find Cheap Belgaum to Mysore Cab services offering competitive fares, dependable drivers, and comfortable vehicles. Choose a budget-friendly travel option for one way trips, family travel, business journeys, and planned outstation transportation."
  },
  {
    "name": "Best Belgaum to Mysore Cab Service",
    "description": "Choose the Best Belgaum to Mysore Cab Service for dependable transportation with professional chauffeurs, well-maintained vehicles, convenient pickup, and flexible booking options. Suitable for families, corporate travelers, tourists, and individual passengers."
  },
  {
    "name": "Online Belgaum to Mysore Cab Booking",
    "description": "Book Online Belgaum to Mysore Cab Booking for quick and convenient reservations with multiple vehicle categories. Plan your journey in advance with flexible pickup locations, easy booking assistance, and comfortable chauffeur-driven cabs."
  },
  {
    "name": "Belgaum to Mysore Taxi Fare",
    "description": "Check Belgaum to Mysore Taxi Fare and select a vehicle according to your travel requirements and budget. Get competitive pricing options for Sedan, Ertiga, Innova Crysta, and SUV cabs for one way and round trip travel."
  },
  {
    "name": "Belgaum to Mysore Car Hire",
    "description": "Hire Belgaum to Mysore Car Hire services with professional drivers and well-maintained vehicles. Perfect for holiday travel, sightseeing, business visits, family trips, and comfortable long-distance transportation."
  },
  {
    "name": "Belgaum to Mysore Cab Price",
    "description": "Check Belgaum to Mysore Cab Price for different vehicle categories and travel requirements. Choose affordable Sedan, Ertiga, Innova Crysta, and SUV options with comfortable interiors and reliable chauffeur service."
  },
  {
    "name": "Belgaum to Mysore Family Cab",
    "description": "Book Belgaum to Mysore Family Cab for a spacious and comfortable journey with experienced drivers. Suitable for family vacations, sightseeing tours, holidays, weekend trips, and travel with children or elderly passengers."
  },
  {
    "name": "Belgaum to Mysore Corporate Taxi",
    "description": "Choose Belgaum to Mysore Corporate Taxi for professional business travel with punctual pickup, executive-friendly vehicles, and experienced chauffeurs. Ideal for meetings, corporate visits, employee travel, and business appointments."
  },
  {
    "name": "Belgaum to Mysore Airport Transfer",
    "description": "Book Belgaum to Mysore Airport Transfer for convenient airport pickup and drop transportation. Travel comfortably with reliable drivers, clean AC vehicles, flexible scheduling, and doorstep service for business and personal journeys."
  },
  {
    "name": "Belgaum to Mysore Cab Fare",
    "description": "Get affordable Belgaum to Mysore Cab Fare with flexible vehicle choices and convenient travel packages. Compare Sedan, Ertiga, Innova Crysta, and SUV options for comfortable one way, round trip, and customized travel requirements."
  },
  {
    "name": "Belgaum to Mysore Taxi Near Me",
    "description": "Find Belgaum to Mysore Taxi Near Me for convenient cab availability and quick booking assistance. Get access to professional chauffeurs, clean AC vehicles, doorstep pickup, and reliable outstation transportation from Belgaum."
  },
  {
    "name": "Belgaum to Mysore Outstation Taxi",
    "description": "Hire Belgaum to Mysore Outstation Taxi for dependable long-distance travel with experienced chauffeurs and comfortable AC vehicles. Choose flexible one way or round trip transportation for holidays, business travel, family trips, and sightseeing."
  },
  {
    "name": "Belgaum to Mysore Travel by Cab",
    "description": "Travel from Belgaum to Mysore by Cab for a comfortable and hassle-free road journey with professional drivers and well-maintained vehicles. Enjoy flexible pickup, spacious seating, convenient travel schedules, and suitable cab options for family, corporate, and leisure travel."
  }
],
"tableData": [
  ["Belgaum to Mysore Cab Service", "Belgaum to Mysore Cab"],
  ["Belgaum to Mysore Taxi", "Belgaum to Mysore Taxi Service"],
  ["Belgaum to Mysore One Way Cab", "Belgaum to Mysore One Way Taxi"],
  ["Belgaum to Mysore Cab Booking", "Belgaum to Mysore Taxi Booking"],
  ["Belgaum to Mysore Car Rental", "Belgaum to Mysore Outstation Cab"],
  ["Belgaum to Mysore Innova Crysta Cab", "Belgaum to Mysore Ertiga Cab"],
  ["Belgaum to Mysore Sedan Cab", "Belgaum to Mysore Round Trip Cab"],
  ["Belgaum to Mysore Private Taxi", "Cheap Belgaum to Mysore Cab"],
  ["Best Belgaum to Mysore Cab Service", "Online Belgaum to Mysore Cab Booking"],
  ["Belgaum to Mysore Taxi Fare", "Belgaum to Mysore Car Hire"],
  ["Belgaum to Mysore Cab Price", "Belgaum to Mysore Family Cab"],
  ["Belgaum to Mysore Corporate Taxi", "Belgaum to Mysore Airport Transfer"],
  ["Belgaum to Mysore Cab Fare", "Belgaum to Mysore Taxi Near Me"],
  ["Belgaum to Mysore Outstation Taxi", "Belgaum to Mysore Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Convenient Belgaum to Mysore Cab Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Mysore with a private taxi service offering flexible travel options, experienced drivers, and well-maintained vehicles for a smooth journey."
  },
  {
    WhyChooseheading: "Private Cab for Hassle-Free Travel",
    WhyChoosedescription: "Enjoy a dedicated vehicle without sharing rides, allowing you to travel with privacy, convenience, and complete control over your journey schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Select from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on passenger count, luggage, and comfort preferences."
  },
  {
    WhyChooseheading: "Ideal for Business & Leisure Trips",
    WhyChoosedescription: "Whether you are travelling for work, family visits, sightseeing, or personal requirements, our Belgaum to Mysore taxis provide a comfortable transportation solution."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Distance Routes",
    WhyChoosedescription: "Skilled chauffeurs ensure smooth highway travel with proper route knowledge, timely service, and a safe driving experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Plans",
    WhyChoosedescription: "Choose a one-way drop taxi or plan a return journey with customized travel schedules according to your convenience."
  },
  {
    WhyChooseheading: "Comfortable Journey Across Karnataka",
    WhyChoosedescription: "Clean interiors, spacious seating, and regularly maintained vehicles make the long-distance trip from Belgaum to Mysore relaxing and enjoyable."
  },
  {
    WhyChooseheading: "Quick Cab Booking Assistance",
    WhyChoosedescription: "Get support for vehicle selection, fare details, and trip planning to arrange your Belgaum to Mysore cab service easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Mysore Cab Service?",
    answer: "Yes, we provide Belgaum to Mysore cab services with comfortable vehicles and professional drivers for outstation travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Mysore?",
    answer: "Yes, one-way taxi service is available for passengers who need direct transportation without a return trip."
  },
  {
    question: "Which vehicles are available for Belgaum to Mysore travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your requirements."
  },
  {
    question: "Is Belgaum to Mysore cab suitable for family travel?",
    answer: "Yes, spacious and comfortable vehicles are available for families, senior citizens, and groups travelling to Mysore."
  },
  {
    question: "Can I book a return taxi from Mysore to Belgaum?",
    answer: "Yes, return journey cabs are available with flexible timings based on your travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I use this cab service for Mysore sightseeing?",
    answer: "Yes, sightseeing stops and customized travel plans can be arranged based on your itinerary."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Mysore taxi available for urgent travel?",
    answer: "Yes, cab booking assistance is available for planned journeys as well as urgent transportation needs."
  },
  {
    question: "How can I book a Belgaum to Mysore Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Patil",
    feedback: "The Belgaum to Mysore cab journey was very comfortable. The driver was professional, the vehicle was clean, and the entire trip was well managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We travelled with family to Mysore and had a pleasant experience. The spacious cab and smooth driving made our long journey enjoyable.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Mysore Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-mysore-cab-service.webp",
  "description":
    "Book Belgaum to Mysore Cab Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Mysore with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, sightseeing tours, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-mysore-cab-service"
  }
};







    return (
        <div>


<Helmet>
  <title>Belgaum to Mysore Cab Service | One Way Taxi | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Mysore Cab Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Mysore with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel, sightseeing, and family trips available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Mysore Cab Service, Belgaum to Mysore Cab, Belgaum to Mysore Taxi, Belgaum to Mysore Taxi Service, Belgaum to Mysore One Way Cab, Belgaum to Mysore One Way Taxi, Belgaum to Mysore Cab Booking, Belgaum to Mysore Taxi Booking, Belgaum to Mysore Car Rental, Belgaum to Mysore Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpeg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomysorecabservice;